import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import NewsStand from "../pages/NewsStand/NewsStand";
import NewsListing from "../pages/NewsListing/NewsListing";
import AccessDenied from "../pages/AccessDenied/AccessDenied";
import NewsVisualizationWeb from "../pages/NewsVisualization/NewsVisualizationWeb/NewsVisualizationWeb";
import NewsVisualizationAudiovisual from "../pages/NewsVisualization/NewsVisualizationAudiovisual/NewsVisualizationAudiovisual";
import NewsVisualizationImpresso from "../pages/NewsVisualization/NewsVisualizationImpresso/NewsVisualizationImpresso";

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route path="/news-listing" element={<NewsListing />} />
        <Route path="/news-stand" element={<NewsStand />} />
        <Route path="/news/web/:id" element={<NewsVisualizationWeb />} />
        <Route path="/news/audiovisual/:id" element={<NewsVisualizationAudiovisual />} />
        <Route path="/news/impresso/:id" element={<NewsVisualizationImpresso />} />
        <Route path="/" element={<Navigate to="/news-stand" replace />} />
        <Route path="/:slug/:token" element={<NewsStand />} />
      </Route>

      <Route path="/access-denied" element={<AccessDenied />} />
      <Route path="/error" element={<ErrorPage code={404} />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  );
}
